import { graphql } from "../generated/gql";

export const GetScorecards = graphql(
  `
    query GetScorecards($filter: GetScoreCardsFilter!) {
      getScorecards(filters: $filter) {
        ... on PaginatedScoreCards {
          __typename
          items {
            ...ScoreCard
          }
          pageInfo {
            total
          }
        }
        ... on GenericException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
      }
    }
  `
);
